<template>
  <div class="border rounded p-1 mb-1">
    <b-row>
      <b-col md="3">
        <b-form-group
          label="Valid from"
          label-for="rate-period-month"
        >
          <flat-pickr
            id="rate-period-month"
            v-model="form.month"
            class="form-control"
            :config="monthConfig"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Hourly rate"
          label-for="rate-period-hourly"
        >
          <b-form-input
            id="rate-period-hourly"
            v-model="form.hourly_rate"
            type="number"
            step="0.01"
            min="0"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Fixed salary"
          label-for="rate-period-salary"
        >
          <b-form-input
            id="rate-period-salary"
            v-model="form.monthly_salary"
            type="number"
            step="0.01"
            min="0"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Employer factor"
          label-for="rate-period-factor"
          description="e.g. 1.3117 Minijob"
        >
          <b-form-input
            id="rate-period-factor"
            v-model="form.employer_factor"
            type="number"
            step="0.0001"
            min="1"
            max="2"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Target hours / month"
          label-for="rate-period-target"
          description="h:mm, e.g. 37:41; empty = no overtime account"
        >
          <b-form-input
            id="rate-period-target"
            v-model="form.target"
            placeholder="h:mm"
            :state="targetValid ? null : false"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Overtime at start"
          label-for="rate-period-opening"
          description="h:mm at the start of this month, may be negative (-3:15)"
        >
          <b-form-input
            id="rate-period-opening"
            v-model="form.opening"
            placeholder="h:mm"
            :state="openingValid ? null : false"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-end">
      <b-button
        size="sm"
        variant="outline-secondary"
        class="mr-50"
        @click="$emit('cancel')"
      >
        Cancel
      </b-button>
      <b-button
        size="sm"
        variant="primary"
        :disabled="!form.month || !targetValid || !openingValid || saving"
        @click="save"
      >
        Save
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BButton, BCol, BFormGroup, BFormInput, BRow,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { parseHm } from '@/utils/hoursMinutes'

export default {
  components: {
    BButton, BCol, BFormGroup, BFormInput, BRow, flatPickr,
  },
  props: {
    // { month: 'YYYY-MM', hourly_rate, monthly_salary, employer_factor, target, opening (h:mm) }
    initial: { type: Object, required: true },
    saving: { type: Boolean, default: false },
  },
  data() {
    return {
      form: { ...this.initial },
      // Any picked day maps to its month; the API normalizes to the 1st.
      monthConfig: { dateFormat: 'Y-m', altInput: true, altFormat: 'F Y' },
    }
  },
  computed: {
    targetMinutes() {
      return parseHm(this.form.target)
    },
    openingMinutes() {
      return parseHm(this.form.opening)
    },
    targetValid() {
      return this.targetMinutes === null || (Number.isInteger(this.targetMinutes) && this.targetMinutes >= 0)
    },
    openingValid() {
      return this.openingMinutes === null || Number.isInteger(this.openingMinutes)
    },
  },
  methods: {
    save() {
      this.$emit('save', {
        valid_from: this.form.month,
        hourly_rate: this.form.hourly_rate || 0,
        monthly_salary: this.form.monthly_salary || 0,
        employer_factor: this.form.employer_factor || 1,
        target_minutes: this.targetMinutes || 0,
        overtime_start_minutes: this.openingMinutes,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
